export const ConsultantIcon = () => (
  <svg width='56' height='56' viewBox='0 0 56 56' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_190_5358)'>
      <path
        d='M56 28C56 43.4642 43.4642 56 28 56C12.5358 56 0 43.4642 0 28C0 12.5358 12.5358 0 28 0C43.4642 0 56 12.5358 56 28Z'
        fill='#2F37ED'
      />
      <path
        d='M56.0004 28.0001C56.0004 27.284 55.973 26.5748 55.9205 25.8724L43.2966 13.2485L12.7041 47.8127L19.6127 54.7213C22.2607 55.5519 25.078 56.0001 28.0004 56.0001C43.4645 56.0001 56.0004 43.4642 56.0004 28.0001Z'
        fill='#0E14A3'
      />
      <path d='M37.4916 7.44336L43.2966 13.2484V47.8126H12.7041V7.44336H37.4916Z' fill='white' />
      <path d='M43.2958 13.2484L37.4908 7.44336H27.9551V47.8126H43.2958V13.2484Z' fill='#E9EDF5' />
      <path d='M37.4912 13.2484V7.44336L43.2962 13.2484H37.4912Z' fill='#CDD2E1' />
      <path
        d='M17.7731 21.9214L14.6875 18.8354L16.2341 17.2888L17.7731 18.8278L21.7503 14.8501L23.2974 16.3972L17.7731 21.9214Z'
        fill='#08875D'
      />
      <path
        d='M17.7731 32.5782L14.6875 29.4927L16.2341 27.9456L17.7731 29.4846L21.7503 25.5073L23.2974 27.0544L17.7731 32.5782Z'
        fill='#08875D'
      />
      <path
        d='M17.7731 43.2354L14.6875 40.1498L16.2341 38.6028L17.7731 40.1417L21.7503 36.1641L23.2974 37.7111L17.7731 43.2354Z'
        fill='#08875D'
      />
      <path d='M25.0469 17.5H39.5938V19.6875H25.0469V17.5Z' fill='#CDD2E1' />
      <path d='M27.9551 17.5H39.5933V19.6875H27.9551V17.5Z' fill='#BEC3D2' />
      <path d='M25.0469 28.3828H39.5938V30.5703H25.0469V28.3828Z' fill='#CDD2E1' />
      <path d='M27.9551 28.3828H39.5933V30.5703H27.9551V28.3828Z' fill='#BEC3D2' />
      <path d='M25.0469 39.2656H39.5938V41.4531H25.0469V39.2656Z' fill='#CDD2E1' />
      <path d='M27.9551 39.2656H39.5933V41.4531H27.9551V39.2656Z' fill='#BEC3D2' />
    </g>
    <defs>
      <clipPath id='clip0_190_5358'>
        <rect width='56' height='56' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
